import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polyline", {
  points: "6.25,2.5 13.75,10 6.25,17.5",
  stroke: "currentColor",
  fill: "none",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeMiterlimit: 10
});

var SvgChevronRight = function SvgChevronRight(props) {
  return _ref;
};

export default SvgChevronRight;